module.exports = __webpack_public_path__ + "img/logo.6bdfbf0.png";